import { Injectable } from '@angular/core';
import { MailStatusesPage } from '../api/legacy/mailstatuses-service/mailstatuses-model';

@Injectable()
export class MailStatusPagingService {
  public page: MailStatusesPage = {
    'pageNumber': 0,
    'size': 10,
    'filterModel':  {
      'searchValue': '',
      'invitationId': null,
      'recipientId': null,
      'attendeeId': null,
      'adHocMailId': null,
      'mailjetStatus': this.getMailjetStatusFilter(),
      'eventMailType': this.getEventMailTypeFilter()
    },
    'eventId': null,
    'campaignId': null,
    'sortProperty': this.getSortProperty(),
    'sortDirection': this.getSortDirection(),
    'totalElements': 0,
    'totalPages': 0
  };

  public setMailjetStatusFilter(value: number) {
    localStorage.setItem('mailStatusesMailjetStatus', value.toString());
  }

  public getMailjetStatusFilter(): number {
      let value = parseInt(localStorage.getItem('mailStatusesMailjetStatus'), 10);
      if (isNaN(value)) {
        value = 0;
      }
      return value;
  }

  public setEventMailTypeFilter(value: number) {
    localStorage.setItem('mailStatusesEventMailTypeFilter', value.toString());
  }

  public getEventMailTypeFilter(): number {
      let value = parseInt(localStorage.getItem('mailStatusesEventMailTypeFilter'), 10);
      if (isNaN(value)) {
        value = 0;
      }
      return value;
  }


  public setSortProperty(value: string) {
    if (value) {
      localStorage.setItem('mailStatusesSortProperty', value);
    } else {
      localStorage.setItem('mailStatusesSortProperty', '');
    }
  }

  public getSortProperty(): string {
    let value = localStorage.getItem('mailStatusesSortProperty');
    if (null === value) {
        value = '';
    }

    return value;
  }

  public setSortDirection(value: string) {
    if (value) {
      localStorage.setItem('mailStatusesSortDirection', value);
    } else {
      localStorage.setItem('mailStatusesSortDirection', '');
    }
  }

  public getSortDirection(): string {
    let value = localStorage.getItem('mailStatusesSortDirection');
    if (null === value) {
        value = '';
    }

    return value;
  }

}
